import React, { useContext, useEffect, useState } from 'react'

import { faCalendar, faPlus } from '@fortawesome/pro-solid-svg-icons'

import DateTitle from './DateTitle'
import { InternshipsManagerContext } from '../../../../Context/InternshipsManager/InternshipsManagerProvider'
import { DAY_AND_MONTH_FORMAT } from '../utils/constants'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const InstitutionDateTitle = ({ startDate, endDate, displayAction, index, isCurrent, t }) => {
  const { highlightedIndexes } = useContext(InternshipsManagerContext)
  const [isHighlighted, setIsHighlighted] = useState(false)

  useEffect(() => {
    if (typeof index !== 'undefined' && highlightedIndexes) {
      setIsHighlighted(index >= highlightedIndexes.startIndex && index <= highlightedIndexes.lastIndex)
    } else {
      setIsHighlighted(false)
    }
  }, [index, highlightedIndexes])

  return (
    <DateTitle
      startDate={startDate}
      endDate={endDate}
      isCurrent={isCurrent}
      dateFormat={DAY_AND_MONTH_FORMAT}
      actionShown={displayAction}
      icon={displayAction ? faPlus : faCalendar}
      iconTitle={t(displayAction ? 'Add an internship' : 'Edit schedules')}
      index={index}
      highlighted={isHighlighted}
      onAction={() => {}}
    />
  )
}

export default connect(mapStateToProps)(InstitutionDateTitle)
